<template>
    <div class="lead">
      <div class="lead__image">
        <VLazyImage
          :src="leadIllustration"
          alt="Ilustração: Rapaz corpulento de camiseta, short e tênis acenando"
          width="191"
          height="362"
        />
      </div>
      <div class="lead__content">
        <ZTitle class="lead__title" size="small">
          Acesse o gabarito do Enem
        </ZTitle>
        <ZText class="lead__text">
          Para acessar e receber novidades sobre o Enem, Sisu, Prouni e Fies, insira seus dados.
        </ZText>

        <form class="lead__form" name="lead">
          <div class="lead__form-inputs">
            <div class="lead-form-field">
              <ZTitle class="lead__form-label" size="nano">
                NOME COMPLETO
              </ZTitle>
              <input
                class="lead__form-input input input--l"
                :class="{ 'input--has-error': errors.has('name') }"
                data-vv-as="nome"
                name="name"
                placeholder="Digite seu nome"
                type="text"
                v-model="form.name"
                v-validate="'required'"
              />
              <span class="lead-form__input__error-message">{{ errors.first('name') }}</span>
            </div>
            <div class="lead-form-field">
              <ZTitle class="lead__form-label" size="nano">
                E-MAIL
              </ZTitle>
              <input
                class="lead__form-input input input--l"
                :class="{ 'input--has-error': errors.has('email') }"
                data-vv-as="e-mail"
                name="email"
                placeholder="Digite seu e-mail"
                type="text"
                v-model="form.email"
                v-validate="'required|email'"
              />
              <span class="lead-form__input__error-message">{{ errors.first('email') }}</span>
            </div>
          </div>
          <ZButton
            class="lead__form-button"
            variant="primary"
            type="submit"
            @click="handleSendForm"
          >
            Acessar o gabarito
          </ZButton>
        </form>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { ZButton, ZText, ZTitle } from '@quero/zilla-vue';
import VLazyImage from "v-lazy-image";

import leadIllustration from '~/assets/images/illustrations/benino-3.0.png';

export default {
  name: 'Lead',
  components: {
    ZButton,
    ZText,
    ZTitle,
    VLazyImage,
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
      },
      submitted: false,
      leadIllustration,
    };
  },
  methods: {
    ...mapActions('lead', {
      setLeadFilled: 'setLeadFilled',
    }),
    handleSendForm(event) {
      event.preventDefault();
      this.$validator.validateAll().then((result) => {
        if(result) {
          window.dataLayer.push(Object.assign({
            event: 'ManualDoEnemLeadSubmit',
            subscription_type: ['gabarito-enem']
          }, this.form));

          this.leadFormSubmit();
        }
      });
    },
    leadFormSubmit(){
      this.setLeadFilled(true);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@quero/zilla-core/src/utils/functions.scss';
  @import '@quero/zilla-core/src/utils/variables.scss';

  .lead {
    align-items: center;
    display: flex;
    height: 100%;
    margin: $space-m 0;
    max-height: 360px;
    padding: $space-m 0;
    width: 100%;

    @media (min-width: $screen-desktop) {
      justify-content: center;
      max-width: 80%;
    }
  }

  .lead__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    @media (min-width: $screen-desktop) {
      max-width: 530px;
    }
  }

  .lead__image {
    display: none;

    @media (min-width: $screen-desktop) {
      display: flex;
      margin-right: $space-st;
    }
  }

  .lead__form {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .lead__form-inputs {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: $screen-desktop) {
      flex-direction: row;
    }
  }

  .lead-form-field {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: $screen-desktop) {
      margin-right: $space-st;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .lead__text {
    margin-bottom: $space-l;
  }

  .lead__title {
    margin-bottom: $space-s;
  }

  .lead__form-label {
    letter-spacing: 0.5px;
    margin-top: $space-s;
  }

  .lead__form-input {
    border: 1px solid var(--color-neutral-gray-light);
    border-radius: $space-xs;
    height: $space-xxl;
    padding: 12px $space-m;
  }

  .lead__form-button {
    margin-top: $space-m;

    @media (min-width: $screen-desktop) {
      max-width: 200px;
    }
  }

  .lead-form__input__error-message {
    color: var(--color-support-danger-deep);
    font-size: rem(12);
  }

</style>
